// const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth'
const logoList = {
    woodworth: {
        LOGO: 'https://res.cloudinary.com/home-space/image/upload/v1705806046/Logo/ww_logo_200x180-b8526767_qxich6.webp',
        PRINT_LOGO:
            'https://res.cloudinary.com/home-space/image/upload/v1705806046/Logo/ww_logo_200x180-b8526767_qxich6.webp',
        PDF: 'https://res.cloudinary.com/home-space/image/upload/v1705806046/Logo/ww_logo_200x180-b8526767_qxich6.png',
    },
    dw: {
        LOGO: 'https://res.cloudinary.com/homespace/image/upload/v1717423280/logo/wood_np7djh.webp',
        PRINT_LOGO:
            'https://res.cloudinary.com/home-space/image/upload/v1749230052/Products/DW%20Cabinetry/DW_Logo-01-PNG_sxri7y.webp',
        PDF: 'https://res.cloudinary.com/homespace/image/upload/v1728091503/WechatIMG1259_wpjxpn.png',
    },
}

export default logoList

export const companyInfo = {
    wlink: {
        COMPANY_NAME: 'Woodworth Cabinetry',
        COMPANY_ADDRESS: 'Address: 854 Westport Cres',
        COMPANY_ADDRESS_1: 'Mississauga ON, L5T 1N5',
        COMPANY_PHONE: 'Tel: 905 670 8787',
        COMPANY_WEB_URL: 'https://woodworthcabinetry.com',
        COMPANY_EMAIL: 'Email: sales@de-valor.ca',
    },
    dw: {
        COMPANY_NAME: 'DW Cabinetry',
        COMPANY_ADDRESS: 'Address: 10676 King William Dr',
        COMPANY_ADDRESS_1: 'Dallas, TX 75220 USA',
        COMPANY_PHONE: 'Tel: 214 242 8975',
        COMPANY_WEB_URL: 'https://dw-cabinetry.com',
        COMPANY_EMAIL: 'Email: sales@dw-cabinetry.com',
    },
    nj: {
        COMPANY_NAME: 'DWC NJ LLC.',
        COMPANY_ADDRESS: 'Address: 90 Coles Rd',
        COMPANY_ADDRESS_1: 'Blackwood, NJ 08012 USA',
        COMPANY_PHONE: 'Tel: 856 302 5611',
        COMPANY_WEB_URL: 'https://dwc-nj.com',
        COMPANY_EMAIL: 'Email: info@dwc-nj.com',
    },
}
